export default __webpack_public_path__ + "static/media/polaroid17.9dbfd285.jpg";